// Ordering the shared email index (projectEmails). Two writers put `date` in
// two types: the archiver writes a Firestore Timestamp, the Gmail panel an ISO
// string. Readers sorted on String(date), which compares "Timestamp(seconds=…)"
// with "2026-09-23T…" and puts the panel's three rows in the wrong place. Every
// reader orders through here instead.

export function mailMillis(v) {
  if (!v) return 0;
  if (typeof v.toMillis === 'function') return v.toMillis();
  if (v instanceof Date) return v.getTime();
  if (typeof v.seconds === 'number') return v.seconds * 1000;
  const n = Date.parse(String(v));
  return Number.isFinite(n) ? n : 0;
}

export function newestFirst(rows) {
  return [...rows].sort((a, b) => mailMillis(b.date) - mailMillis(a.date));
}
